<h1 mat-dialog-title>Authentication Required</h1>
<div mat-dialog-content>
  <p>You need to be logged in to perform this action.</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-button color="primary" (click)="onLoginClick()" cdkFocusInitial>Login</button>
</div>
